import { useQuery } from "@tanstack/react-query";
import i18next from "i18next";
import { get } from "lodash";
import moment from "moment";
import React, { useEffect, useMemo, useState } from "react";
import { GamePlayerApi } from "states/api/gamePlayer";
import { formatNumber } from "_common/utils/formatValue";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronRight,
  faLongArrowAltLeft,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { useNotify } from "_common/component/NotifyProvider";

export default function ItemRecord({ item, onGetDetail }) {
  const navigate = useNavigate();
  const { dataGame } = useNotify();

  const timeProcess = useMemo(() => {
    const time = Number(get(dataGame, "time", 0));
    const type = Number(get(dataGame, "type", 0));
    return (time / type) * 100;
  }, [dataGame?.time]);

  return (
    <div key={item.id} className="listbox">
      <div className="listbox_title">
        <div className="listbox_title_l">
          <span
            className={`f14 text-[16px] text-[500] text-[#0ecb81] ${
              item?.bet_game === "sell" && "text-[#f5465c]"
            }`}
          >
            {i18next.t(item?.bet_game)}:
          </span>
          <span className="fcc f14 fe6im text-[16px] text-[500] text-uppercase">
            {item?.game?.name}
          </span>
        </div>
        <div onClick={() => onGetDetail(item)}>
          <div className="listbox_title_r">
            <span className="fcc text-[12px] text-[#A9AEB8]">
              {i18next.t(item?.status)}
            </span>
            <FontAwesomeIcon
              icon={faChevronRight}
              color="#e6e6e6"
              className="ml-[5px]"
            />
          </div>
        </div>
      </div>
      <div className="w-full h-[60px]">
        <div className="w-[33%] h-[60px] inline-block">
          <div className="w-full h-[30px] leading-[40px]">
            <span className="f12 text-[#6B7785]">Số tiền đầu tư</span>
          </div>
          <div className="w-full h-[30px] leading-[30px]">
            <span className="f12 text-[#A9AEB8]">
              {formatNumber(item?.amount, "0,0.[000000]")}
            </span>
          </div>
        </div>
        <div className="w-[33%] h-[60px] inline-block">
          <div className="w-full h-[30px] leading-[40px]">
            <span className="f12 text-[#6B7785]">Giá mở lệnh</span>
          </div>
          <div className="w-full h-[30px] leading-[30px]">
            <span className="f12 text-[#A9AEB8]">
              {formatNumber(item?.open, "0,0.[000000]")}
            </span>
          </div>
        </div>
        <div className="w-[33%] h-[60px] inline-block">
          <div className="w-full h-[30px] leading-[40px] text-right">
            <span className="f12 text-[#6B7785]">Thiết lập thời gian</span>
          </div>
          <div className="w-full h-[30px] leading-[30px] text-right">
            <span className="f12 text-[#A9AEB8]">
              {moment(item?.created_at).format("MM-DD HH:mm")}
            </span>
          </div>
        </div>
      </div>
      {item?.status === "bet" && (
        <div className="progress h-[10px] bg-[#1b1d29]">
          <div className="progress-bar" style={{ width: `${timeProcess}%` }} />
          <div className="txt">{formatNumber(dataGame?.time)} S</div>
        </div>
      )}
    </div>
  );
}
